var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.42 28.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-close-1{fill:#ffffff;fill-rule:evenodd;padding:5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M_310_Global_Header_standard-menu_M_310_Global_Header-standard-menu-M",
    "data-name": "M_310_Global_Header/standard-menu/M_310_Global_Header-standard-menu-M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_close_menu",
    "data-name": "icon close menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-close-1",
    d: "M14.21,11.63,25.83,0l2.59,2.58L16.79,14.21,28.42,25.83l-2.59,2.59L14.21,16.79,2.58,28.42,0,25.83,11.63,14.21,0,2.58,2.58,0Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIco);
export default __webpack_public_path__ + "static/media/close_ico.db58c70d9eada242607f9fd6cd03853a.svg";
export { ForwardRef as ReactComponent };